import React from "react"
import AllAsperaDownloads from "../Customer/aspera_downloads"

const AsperaDownloads = () => <AllAsperaDownloads queries={{}} includeSearch={true} includeTitle={true}/>

export default AsperaDownloads
